import axios from 'axios'
import { toastr } from 'react-redux-toastr'
import { URL } from '../../assets/js/constants'

export function carregarNotificacoes(data) {
    return {
        type: 'NOTIFICACOES_FETCHED',
        payload: data
    }
}

export function getNotificacoes(negocio) {
    return dispatch => {
        axios.get(`${URL}/duvidas/vendedor/perguntas-nao-lidas/${negocio}`)
            .then(resp => dispatch(carregarNotificacoes(resp.data)))
            .catch(e => toastr.error('Erro', e.message))
    }
}